import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { TagCatalogApi, TagCatalogComponent } from "src/app/components/tag-catalog/tag-catalog.component";
import { ActivitySection } from "src/app/constants/activity-log";
import { ActivityLogService } from "src/app/services/activity-log.service";
import { ProjectHubService } from "src/app/services/project-hub.service";

/** Spark tag 1 is the system "Email" tag: always shown under that name, never editable. */
const EMAIL_TAG_ID = 1;

/** Admin ▸ Tags ▸ Spark - same catalog UI as the Aufgaben and Kontakte tabs. */
@Component({
  selector: "app-config-spark-tags.page",
  imports: [TagCatalogComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<app-tag-catalog [api]="api" [heading]="heading" [description]="description"></app-tag-catalog>`,
})
export class ConfigSparkTagsPageComponent implements OnInit {
  readonly heading = $localize`:@@sparkTagsTitle:Spark Tags`;
  readonly description = $localize`:@@sparkTagsDescription:Define tags to categorise sparks.`;

  private sparkTags: any[] = [];

  readonly api: TagCatalogApi = {
    load: async () => {
      const result = await this.service.getSparkTags({});
      this.sparkTags = result.sparkTags ?? [];
      return {
        ...result,
        tags: this.sparkTags.map((t) =>
          t.id === EMAIL_TAG_ID ? { id: t.id, name: "Email", locked: true } : { id: t.id, name: t.name }
        ),
      };
    },
    save: (id, name) => {
      const existing = this.sparkTags.find((t) => t.id === id);
      return this.service.writeSparkTags({ sparkTag: { ...(existing ?? {}), id, name } });
    },
    remove: (tag) => {
      const existing = this.sparkTags.find((t) => t.id === tag.id);
      return this.service.writeSparkTags({ sparkTag: { ...existing, isDeleted: true } });
    },
  };

  constructor(private service: ProjectHubService, private activityLog: ActivityLogService) {}

  ngOnInit(): void {
    this.activityLog.logView({ Section: ActivitySection.CONFIG_TAGS });
  }
}
